//document.addEventListener("DOMContentLoaded", function() {});
//(function() {

// add grid function
function GetIEVersion() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0) {
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

    // If IE 11 then look for Updated user agent string.
  } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
    return 11;

  } else {
    return 0; //It is not IE
  }

}

/*if (GetIEVersion() > 0)
   alert("This is IE " + GetIEVersion());
else
   alert("This is not IE.");*/;

// add loadscript function
// https://javascript.info/callbacks
function loadScript(src, callback) {
  let script = document.createElement('script');
  script.src = src;
  script.onload = () => callback(script);
  document.head.append(script);
};

// add grid function
function media__sizes(size) {
  if (!size) {
    var size = 'sm';
  }
  let size_px = 576;
  switch (size) {
    case 'sm':
      size_px = 576;
      break;

    case 'md':
      size_px = 768;
      break;

    case 'lg':
      size_px = 992;
      break;

    case 'xl':
      size_px = 1200;
      break;

  }
  return size_px;
}

function media_breakpoint_up(size) {
  if (!size) {
    var size = 'sm';
  }
  let size_px = media__sizes(size);
  return window.matchMedia("(min-width: " + size_px + "px)").matches;
}

function media_breakpoint_down(size) {
  if (!size) {
    var size = 'sm';
  }
  let size_px = media__sizes(size);
  return window.matchMedia("(max-width: " + size_px + "px)").matches;
}
//});;

// add viewport function
//@ import '../../../../../../typo3/t3lmwa_distribution_gridelements/Frontend/assets/js/default/viewport.js';

// add video
/**
 * Youtube 2 Klick Lösung
 * @author Jolution
 */
(function() {
  "use strict";

  var youtube = document.querySelectorAll(".youtube-thumb");

  for (var i = 0; i < youtube.length; i++) {


    // Dev Function:
    //document.write("<br><br><b>DEV ONLY: <a href='https://img.youtube.com/vi/" + youtubeID + "/maxresdefault.jpg' download>Download Thumb local<\/b>");
    // Alternative: mqdefault.jpg, 0.jpg, hqdefault.jpg, maxresdefault.jpg

    youtube[i].getElementsByClassName("youtube-play-button")[0].addEventListener("click", function() {

      var youtubeTarget = this.parentNode.parentNode,
        youtubeID = youtubeTarget.dataset.embed,
        youtubeURL = 'https://www.youtube-nocookie.com/embed/' + youtubeID + '?rel=0&autoplay=1',
        wrapperWidth = youtubeTarget.dataset.width,
        wrapperHeight = youtubeTarget.dataset.height;

      // <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/AqcjdkPMPJA" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      var iframe = document.createElement("IFRAME");
      iframe.setAttribute("src", youtubeURL);
      iframe.setAttribute("width", wrapperWidth);
      iframe.setAttribute("height", wrapperHeight);
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allow", "autoplay; encrypted-media");
      iframe.setAttribute("allowfullscreen", "");

      youtubeTarget.parentNode.replaceChild(iframe, youtubeTarget);
      //this.innerHTML = "";
      //this.appendChild( iframe );

    });

  }

})();;

// add googlemap
/**
 * Googlemap 2 Klick Lösung
 * @author Jolution
 */

(function() {
  "use strict";

  //document.addEventListener("DOMContentLoaded", function(event) {

  var googlemap = document.querySelectorAll(".googlemap-thumb");

  for (var i = 0; i < googlemap.length; i++) {

    var playButton = googlemap[i].getElementsByClassName("googlemap-play-button")[0];

    playButton.addEventListener("click", function() {

      var googlemapTarget = this.parentNode.parentNode,
        googlemapID = googlemapTarget.dataset.embed,
        googlemapURL = 'https://www.google.com/maps/embed?pb=' + googlemapID,
        wrapperWidth = googlemapTarget.dataset.width || '100%',
        wrapperHeight = googlemapTarget.dataset.height || '100%';

      var iframe = document.createElement("IFRAME");
      iframe.setAttribute("src", googlemapURL);
      iframe.setAttribute("width", wrapperWidth);
      iframe.setAttribute("height", wrapperHeight);
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");

      googlemapTarget.parentNode.replaceChild(iframe, googlemapTarget);

    });

  }

})();;

// add progressive img
/*var a = document.querySelector('.ctabar');

document.addEventListener("DOMContentLoaded", function() {
  if (!a) return !1;
  var b = a.getAttribute("data-img-full"),
    c = document.querySelector('.background'),
    img = new Image;

  img.src = b;
  img.onload = function() {
    c.classList.add('is-loaded'),
      c.style.backgroundImage = 'url(' + b + ')';
  };
});*/

// Inspired: https://www.sitepoint.com/how-to-build-your-own-progressive-image-loader/

//if (window.addEventListener && window.requestAnimationFrame && document.getElementsByClassName) window.addEventListener('load', function() {
var pItem = document.getElementsByClassName('progressiveimg replace'),
  timer;
//});

// image in view?
function inView() {
  var wT = window.pageYOffset,
    wB = wT + window.innerHeight,
    cRect, pT, pB, p = 0;
  while (p < pItem.length) {

    cRect = pItem[p].getBoundingClientRect();
    pT = wT + cRect.top;
    pB = pT + cRect.height;

    if (wT < pB && wB > pT) {
      loadFullImage(pItem[p]);
      pItem[p].classList.remove('replace');
    } else p++;
  }
}

// before scroll
inView();

// replace with full image
function loadFullImage(item) {

  //var a = document.querySelector('.ctabar');

  //document.addEventListener("DOMContentLoaded", function() {
  if (!item) return;
  var b = item.getAttribute("data-img-full"),
    c = item.querySelector('.background'),
    img = new Image;

  img.src = b;
  img.onload = function() {
    c.classList.add('is-loaded'),
      c.style.backgroundImage = 'url(' + b + ')';
  };
  //});
}

window.addEventListener('scroll', scroller, false);
window.addEventListener('resize', scroller, false);

function scroller(e) {
  timer = timer || setTimeout(function() {
    timer = null;
    requestAnimationFrame(inView);
  }, 300);
};

// add parallax
/*document.addEventListener("DOMContentLoaded", function() {
  if (media_breakpoint_up('md')) {
    $('.scene').parallax();
  }
});*/;

// add Slider
//@ import '../../../../../../typo3/t3lmwa_distribution_gridelements/Frontend/assets/js/slider/slider.js';
document.addEventListener("DOMContentLoaded", function() {


  if (document.getElementsByClassName("t3lmwaslider")[0] != null) {
    /*var flkty = new Flickity('.t3lmwaslider', {
      bgLazyLoad: true,
      adaptiveHeight: false,
      freeScroll: false,
      draggable: false,
      arrowShape: 'M 0,50 L 60,00 L 50,30 L 80,30 L 80,70 L 50,70 L 60,100 Z'
    });*/

    // external js: flickity.pkgd.js

    var utils = window.fizzyUIUtils,
      sliders = document.querySelectorAll('.t3lmwaslider'),
      cellsButtonGroup, cellsButton, previousSelectedButton, selectedButton;

    //[].forEach.call(containers, function(container) {
    for (var i = 0, len = sliders.length; i < len; i++) {

      // ie and edge fix
      var container = sliders[i];

      var container__flkty = container.querySelector('.slider__slide__wrapper'),
        flkty = new Flickity(container__flkty, {
          prevNextButtons: false,
          pageDots: false,
          draggable: false,
          imagesLoaded: true,
          adaptiveHeight: false,
          bgLazyLoad: true
        });

      // Counter Bar Bottom
      /*if (container.getElementsByClassName("slider__control__wrapper")[0] != null) {
        var cellsButtonGroup = container.querySelector('.slider__control__wrapper'),
          cellsButtons = utils.makeArray(cellsButtonGroup.children);
      }

      // Widget Right
      if (container.getElementsByClassName("slider__widget__nav")[0] != null) {
        var cellsCardGroup = container.querySelector('.slider__widget__nav'),
          cellsCards = utils.makeArray(cellsCardGroup.children);
      }*/

      /*if (GetIEVersion() == '11') {
        cellsCardGroup.setAttribute("style", "display:none !important");
      } else {*/

      var navs = container.querySelector('.slider__widget__nav');

      if (flkty.cells.length > 3 && GetIEVersion() != '11') {
        navs.setAttribute("style", "transform: translateY(0);");
      } else {
        navs.setAttribute("style", "transform: translateY(-50%);");
      }
      //}

      // update buttons on select
      flkty.on('select', function(index) {

        // index = Zero-based number of the selected slide.
        // Src: https://flickity.metafizzy.co/events.html
        var slider = this.slider.parentNode.parentNode.parentNode;

        // Counter Bar Bottom
        var dots = slider.querySelector('.slider__control__wrapper'),
          previousSelectedButton = dots.querySelector('.is-selected'),
          selectedButton = dots.children[index];
        //selectedButton = dots.children[flkty.selectedIndex];
        previousSelectedButton.classList.remove('is-selected');
        selectedButton.classList.add('is-selected');

        // Widget Right
        var navs = slider.querySelector('.slider__widget__nav'),
          previousSelectedCard = navs.querySelector('.is-selected'),
          selectedCard = navs.children[index];
        previousSelectedCard.classList.remove('is-selected');
        selectedCard.classList.add('is-selected');

        // Widget Right Postion
        var flkty = Flickity.data(this.slider.parentNode.parentNode);
        var widgetProz = 0;
        if (flkty.cells.length > 3 && GetIEVersion() != '11') {
          if (index > 0) {
            widgetProz = 20 * index;
            navs.setAttribute("style", "transform: translateY(-" + widgetProz + "vh);");
          } else {
            navs.setAttribute("style", "transform: translateY(0);");
          }
        }

      });

      // cell select


      // Counter Bar Bottom
      if (container.querySelector('.slider__control__wrapper') != null) {
        var dots = container.querySelector('.slider__control__wrapper');

        dots.addEventListener('click', function(event) {
          if (!matchesSelector(event.target, '.slider__control__index')) {
            return;
          }

          var dots = utils.makeArray(event.target.parentNode.children),
            index = dots.indexOf(event.target);

          var flkty = Flickity.data(event.target.parentNode.parentNode.parentNode.children[0]);
          flkty.select(index);
        });
      }

      // Widget Right
      navs.addEventListener('click', function(event) {
        if (!matchesSelector(event.target, '.slider__widget__index')) {
          return;
        }

        var navs = utils.makeArray(event.target.parentNode.children),
          index = navs.indexOf(event.target);

        var flkty = Flickity.data(event.target.parentNode.parentNode.parentNode.children[0]);
        flkty.select(index);
      });


      // previous
      var previousButton = container.querySelector('.arrow--previous');
      previousButton.addEventListener('click', function(event) {
        //console.log(event.target.parentNode.dataset.indexNumber);
        var flkty = Flickity.data(event.target.parentNode.parentNode.children[0]);
        flkty.previous();
      });
      // next
      var nextButton = container.querySelector('.arrow--next');
      nextButton.addEventListener('click', function() {
        var flkty = Flickity.data(event.target.parentNode.parentNode.children[0]);
        flkty.next();
      });


    }


  }

  /*
  var slider = jQuery('.slider');
  slider.imagesLoaded(function() {
    slider.flickity({
      bgLazyLoad: true,
      adaptiveHeight: false,
      freeScroll: false,
      draggable: false,
    });
  });*/
});;

// add Contentslider
document.addEventListener("DOMContentLoaded", function() {


  if (document.getElementsByClassName("contentslider")[0] != null) {
    /*var flkty = new Flickity('.contentslider', {
      bgLazyLoad: true,
      adaptiveHeight: false,
      freeScroll: false,
      draggable: false,
      arrowShape: 'M 0,50 L 60,00 L 50,30 L 80,30 L 80,70 L 50,70 L 60,100 Z'
    });*/

    // external js: flickity.pkgd.js

    var utils = window.fizzyUIUtils,
      contentsliders = document.querySelectorAll('.contentslider'),
      cellsButtonGroup, cellsButton, previousSelectedButton, selectedButton;

    //[].forEach.call(contentsliders, function(container) {
    for (var i = 0, len = contentsliders.length; i < len; i++) {

      // ie and edge fix
      var container = contentsliders[i];

      // init multiply flickity slider
      var container__flkty = container.querySelector('.slider__slide__wrapper'),
        flkty = new Flickity(container__flkty, {
          prevNextButtons: false,
          pageDots: false,
          cellAlign: "left"
        });

      // Counter Bar Bottom
      //var cellsButtonGroup = container.querySelector('.flickity-page-dots__wrapper'),
      //cellsButtons = utils.makeArray(cellsButtonGroup.children);

      if (container.querySelector('.flickity-page-dots__wrapper') != null) {
        // update buttons on select
        flkty.on('select', function(index) {

          // index = Zero-based number of the selected slide.
          // Src: https://flickity.metafizzy.co/events.html

          var contentslider = this.slider.parentNode.parentNode.parentNode,
            dots = contentslider.querySelector('.flickity-page-dots__wrapper');

          // Counter Bar Bottom
          var previousSelectedButton = dots.querySelector('.is-selected'),
            selectedButton = dots.children[index];
          //selectedButton = dots.children[flkty.selectedIndex];
          previousSelectedButton.classList.remove('is-selected');
          selectedButton.classList.add('is-selected');

        });

        // cell select

        // Counter Bar Bottom
        var dots = container.querySelector('.flickity-page-dots__wrapper');

        dots.addEventListener('click', function(event) {
          if (!matchesSelector(event.target, '.dot')) {
            return;
          }

          var dots = utils.makeArray(event.target.parentNode.children),
            index = dots.indexOf(event.target);

          var flkty = Flickity.data(event.target.parentNode.parentNode.parentNode.children[0]);
          flkty.select(index);
        });
      }


      // previous
      var previousButton = container.querySelector('.arrow--previous');
      previousButton.addEventListener('click', function(event) {
        //console.log(event.target.parentNode.dataset.indexNumber);
        var flkty = Flickity.data(event.target.parentNode.parentNode.children[0]);
        flkty.previous();
      });
      // next
      var nextButton = container.querySelector('.arrow--next');
      nextButton.addEventListener('click', function() {
        var flkty = Flickity.data(event.target.parentNode.parentNode.children[0]);
        flkty.next();
      });


    }


  }

});;
//@ import '../../../../../../typo3/t3lmwa_distribution_gridelements/Frontend/assets/js/contentslider/contentslider.js';

// add Full Screen Search
/* ==========================================================================
   Full Screen Search
   ========================================================================== */

//$(function () {

if (document.getElementsByClassName('search__icon')[0] != null) {

  var search__icon = document.getElementsByClassName('search__icon')[0],
    search__form = document.getElementById('search'),
    search__input = document.getElementById('s');

  search__icon.addEventListener('click', function(event) {
    event.preventDefault();
    search__form.classList.add('open');
    search__input.focus();
  });

  search__form.addEventListener('click', function(event) {
    if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
      search__form.classList.remove('open');
    }
  });

}


/*
	    $('#search, #search button.close').on('click keyup', function(event) {
	        if (event.target == this || event.target.className == 'close' || event.keyCode == 27) {
	            $(this).removeClass('open');
	        }
	    });
*/
/*$('form').submit(function(event) {
    event.preventDefault();
    return false;
});*/
//});;

// add hotspotmap1
function addEventListenerByClass(className, event, fn) {
  var list = document.getElementsByClassName(className);
  for (var i = 0, len = list.length; i < len; i++) {
    list[i].addEventListener(event, fn, false);
  }
}

// Hotspotmap
var hotspotEvent = function(e) {
  e.preventDefault();
  var list = document.getElementsByClassName('spot');
  for (var i = 0, len = list.length; i < len; i++) {
    list[i].classList.remove('active');
  }
  this.classList.add('active');

  if (window.matchMedia("(max-width: 1199px)").matches) {

    // Scroll to a certain element
    //document.querySelector('.spot.active').scrollIntoView({
    this.scrollIntoView(true);
    /*{
                  behavior: 'smooth'
              });*/

    // now account for fixed header
    var scrolledY = window.scrollY;

    if (scrolledY) {
      window.scroll(0, scrolledY - 100);
    }
  }
}

var imageMap = document.getElementsByClassName('imageMap');
if (document.getElementsByClassName('imageMap') != null) {
  addEventListenerByClass('spot', 'click', hotspotEvent);
};

//})();